import JobItem from "./jobItem";
import type { JobListing } from "#/types/types";

export default function JobList({
  postings,
}: {
  postings: JobListing[];
}) {
  return (
    <>
      {postings.map((post, index) => {
        const title = createTitle(post, index);
        return <JobItem key={title} title={title} job={post} index={index} />;
      })}
    </>
  );
}

function createTitle(post: JobListing, index: number) {
  const salary = formatAsCurrency(post.salary);

  return (
    [
      `${salary} • Hiring ${post.positionTitle} Physician in ${post.city}`,
      `${salary} • ${post.positionTitle} position in ${post.city}`,
      `${salary} • ${post.positionTitle} vacancy in ${post.city}`,
      `${salary} • ${post.positionTitle} need in ${post.city}`,
      `${salary} • ${post.positionTitle} opening in ${post.city}`,
      `${salary} • ${post.positionTitle} wanted in ${post.city}`,
      `${salary} • Hiring ${post.positionTitle} in ${post.city}`,
      `${salary} • ${post.positionTitle} position opened in ${post.city}`,
      `${salary} • ${post.positionTitle} needed in ${post.city}`,
      `${salary} • ${post.positionTitle} opportunity in ${post.city}`,
      `${salary} • ${post.positionTitle} vacancy in ${post.city}`,
      `${salary} • ${post.positionTitle} needed in ${post.city}`,
      `${salary} • ${post.positionTitle} opening in ${post.city}`,
      `${salary} • ${post.positionTitle} wanted in ${post.city}`,
      `${salary} • Hiring ${post.positionTitle} in ${post.city}`,
      `${salary} • ${post.positionTitle} position in ${post.city}`,
      `${salary} • ${post.positionTitle} vacancy in ${post.city}`,
      `${salary} • ${post.positionTitle} needed in ${post.city}`,
      `${salary} • ${post.positionTitle} opening in ${post.city}`,
      `${salary} • ${post.positionTitle} wanted in ${post.city}`,
    ][index] ?? ""
  );
}

function formatAsCurrency(number: number, currencyCode = "USD"): string {
  return number.toLocaleString("en-US", {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: 0,
  });
}
